import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

export const systemConfigGuard: CanActivateFn = (route, state) => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  if (configService.config() && !configService.error()) {
    return true;
  }

  if (configService.error() || (!configService.loading() && !configService.config())) {
    router.navigate(['/system-error']);
    return false;
  }

  // While still initial loading, allow transition
  return true;
};
